import Icon from '../components/Icon.vue'

Icon.register({
  barcode: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 448v-384h18v384h-18zM26.9 447.7v-383.7h9.1v383.7h-9.1zM54 447.7v-383.7h8.9v383.7h-8.9zM98.9 447.7v-383.7h8.9v383.7h-8.9zM134.9 447.7v-383.7h17.7v383.7h-17.7zM179.7 447.7v-383.7h8.9v383.7h-8.9zM197.7 447.7v-383.7h8.9v383.7h-8.9zM215.7 447.7v-383.7h8.9v383.7h-8.9zM251.4 447.7v-383.7h18v383.7h-18zM296.3 447.7v-383.7h18v383.7h-18zM332.3 447.7v-383.7h18v383.7h-18zM368.3 447.7v-383.7h18v383.7h-18zM395.1 447.7v-383.7h18v383.7h-18zM440.3 447.7v-383.7h26.9v383.7h-26.9zM476 447.7v-383.7h9.1v383.7h-9.1zM494 448v-384h18v384h-18z'
      }
    ]
  }
})
